import { useSelector } from "react-redux";
import { PROPOSAL_RIDERS } from "../../constant/gms-constant";
import { selectedGTPDRCRState, selectedRidersState } from "../../features/gms-proposal-forms/attachable-rider/attachable-riders.slice";
import { useToastify } from "../../library/toastify/toast-provider";

export const useRiderValidation = () => {

    const { showToastNotify } = useToastify();
    const selectedRiders = useSelector(selectedRidersState);
    // const selectedGHIR = useSelector(selectedGHIRState);
    // const selectedGAMERR14 = useSelector(selectedGAMERR14State);
    // const selectedGAMERR9 = useSelector(selectedGAMERR9State);
    const selectedGTPDRCR = useSelector(selectedGTPDRCRState);

    const hasGHIR = selectedRiders?.some((r) => Object.values(PROPOSAL_RIDERS.GHIR.productFor).some((id) => id === r.id)) ?? false;
    const hasGAMERR14 = selectedRiders?.some((r) => r.id === PROPOSAL_RIDERS.GAMERR.productFor.GPA) ?? false;
    const hasGAMERR9 = selectedRiders?.some((r) => r.id === PROPOSAL_RIDERS.GAMERR.productFor.GYRT) ?? false;
    const hasGTPDRCR = selectedRiders?.some((r) => r.id === PROPOSAL_RIDERS.GTPDRC.productFor.GCLI) ?? false;

    // const valueGHIR = selectedGHIR?.inputs[0]?.fAmount;
    // const valueGAMERR14 = selectedGAMERR14?.inputs[0]?.fAmount;
    // const valueGAMERR9 = selectedGAMERR9?.inputs[0]?.fAmount;
    const valueGTPDRCR = selectedGTPDRCR?.inputs[0]?.fAmount;

    // const validateGHIR = () => {
    //     if (!hasGHIR) return true;

    //     const num = Number(valueGHIR);
    //     if (num < 100 || num > 300 || num === 0 || isNaN(num)) {
    //         showToastNotify(
    //             "Please enter an amount between 100 and 300 for Group Hospital Income Rider.",
    //             "warning"
    //         );
    //         return false;
    //     }
    //     return true;
    // };

    // const validateGAMERR14 = () => {
    //     if (!hasGAMERR14) return true;

    //     const num = Number(valueGAMERR14);
    //     if (num < 500 || num === 0 || isNaN(num)) {
    //         showToastNotify( "Please enter at least 500 for Group Accidental Medical Expense Reimbursement Rider.", "warning" );
    //         return false;
    //     }
    //     return true;
    // };

    // const validateGAMERR9 = () => {
    //     if (!hasGAMERR9) return true;

    //     const num = Number(valueGAMERR9);
    //     if (num < 500 || num === 0 || isNaN(num)) {
    //         showToastNotify( "Please enter at least 500 for Group Accidental Medical Expense Reimbursement Rider.", "warning" );
    //         return false;
    //     }
    //     return true;
    // };

    const validateGTPDRCR = () => {
        if (!hasGTPDRCR) return true;

        const num = Number(valueGTPDRCR);

        // ✅ FIX: don't block 0 before checking
        if (valueGTPDRCR == null || isNaN(num)) {
            showToastNotify( "Please enter an amount for Total and Permanent Disability Rider for Creditors.", "warning" );
            return false;
        }

        if (num <= 0) {
            showToastNotify( "Please enter an amount for Total and Permanent Disability Rider for Creditors.", "warning" );
            return false;
        }

        return true;
    };

    

    const validateAll = () => {
        // if (!validateGHIR()) return false;
        // if (!validateGAMERR14()) return false;
        // if (!validateGAMERR9()) return false;
        // if (!validateGTPDRCR()) return false;

        return true;
    };

    return {
        validateAll,
        hasGHIR,
        hasGAMERR14,
        hasGAMERR9,
        validateGTPDRCR
    };
};